<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__payrecord}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:payrecord:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:payrecord:delete')"
            type="danger"
            @click="deleteHandle()"
            >{{ $t("deleteBatch") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="imgs"
          label="凭证"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="状态   0 待处理   1已完成"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="amount"
          label="金额"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          label="客户"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="factoryName"
          label="工厂"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="companyName"
          label="供应商"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="receiptCode"
          label="发票号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('trade:payrecord:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
            <el-button
              v-if="$hasPermission('trade:payrecord:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/payrecord/page",
        getDataListIsPage: true,
        exportURL: "/trade/payrecord/export",
        deleteURL: "/trade/payrecord",
        deleteIsBatch: true,
      },
      dataForm: {
        id: "",
      },
    };
  },
  methods: {
    beforeTableBinding(dataList) {
      if (!dataList || dataList.length === 0) {
        return;
      }
    },
  },
  components: {},
};
</script>
